import { Platform, StyleSheet } from 'react-native';

import { monoFont } from './agentsPageStyles';

const cardShadow = Platform.select({
    web: { boxShadow: '0 18px 48px rgba(34, 44, 33, 0.08)' },
    default: {
        elevation: 3,
        shadowColor: '#1b281d',
        shadowOffset: { width: 0, height: 12 },
        shadowOpacity: 0.08,
        shadowRadius: 20,
    },
});

export const contentStyles = StyleSheet.create({
    routesGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 16,
        marginTop: 46,
    },
    routeCard: {
        backgroundColor: '#213725',
        borderColor: '#3b5740',
        borderRadius: 14,
        borderWidth: 1,
        flexBasis: '47%',
        flexGrow: 1,
        minWidth: 280,
        paddingHorizontal: 24,
        paddingVertical: 25,
    },
    routeCardNarrow: {
        flexBasis: '100%',
        minWidth: 0,
    },
    routeLabel: {
        color: '#9eb99a',
        fontSize: 11,
        fontWeight: '600',
        textTransform: 'uppercase',
    },
    routeTitle: {
        color: '#fffdf8',
        fontSize: 20,
        fontWeight: '600',
        lineHeight: 26,
        marginTop: 13,
    },
    routeBody: {
        color: '#bcc8bd',
        fontSize: 14,
        lineHeight: 23,
        marginTop: 10,
    },
    routeCode: {
        color: '#e0e6d9',
        fontFamily: monoFont,
        fontSize: 11,
        lineHeight: 18,
        marginTop: 15,
    },
    textLinkLight: {
        color: '#b9dbac',
        fontSize: 13,
        fontWeight: '600',
        marginTop: 20,
        textDecorationLine: 'none',
    },
    agentCards: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 16,
        marginTop: 46,
    },
    agentCard: {
        backgroundColor: '#fffdf8',
        borderColor: '#d7d1c5',
        borderRadius: 14,
        borderWidth: 1,
        flexBasis: '47%',
        flexGrow: 1,
        minWidth: 280,
        paddingHorizontal: 24,
        paddingVertical: 25,
        ...cardShadow,
    },
    agentCardNarrow: {
        flexBasis: '100%',
        minWidth: 0,
    },
    agentCardTitleRow: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    agentCardTitle: {
        color: '#1b2b1e',
        fontSize: 20,
        fontWeight: '600',
        lineHeight: 26,
    },
    agentCardAccess: {
        color: '#497147',
        fontSize: 10,
        fontWeight: '500',
        textTransform: 'uppercase',
    },
    agentCardBody: {
        color: '#59635a',
        fontSize: 14,
        lineHeight: 23,
        marginTop: 14,
    },
    agentCardLink: {
        color: '#416e3e',
        fontSize: 13,
        fontWeight: '600',
        marginTop: 18,
        textDecorationLine: 'none',
    },
    matrixNote: {
        color: '#667066',
        fontSize: 13,
        lineHeight: 21,
        marginBottom: 28,
        marginTop: 16,
    },
    useCaseGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 14,
        marginTop: 46,
    },
    useCaseCard: {
        backgroundColor: '#fffdf8',
        borderColor: '#d9d3c6',
        borderRadius: 12,
        borderWidth: 1,
        flexBasis: '30%',
        flexGrow: 1,
        minWidth: 250,
        paddingHorizontal: 21,
        paddingVertical: 22,
    },
    useCaseCardNarrow: {
        flexBasis: '100%',
        minWidth: 0,
    },
    useCaseIndex: {
        color: '#e35b16',
        fontSize: 11,
        fontWeight: '500',
    },
    useCaseTitle: {
        color: '#1b2b1e',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 22,
        marginTop: 14,
    },
    useCaseBody: {
        color: '#5a645b',
        fontSize: 14,
        lineHeight: 23,
        marginTop: 8,
    },
    promptsGrid: {
        gap: 12,
        marginTop: 42,
    },
    promptCard: {
        backgroundColor: '#203625',
        borderColor: '#3a5940',
        borderRadius: 10,
        borderWidth: 1,
        flexDirection: 'row',
        gap: 20,
        paddingHorizontal: 20,
        paddingVertical: 18,
    },
    promptCardStacked: {
        flexDirection: 'column',
        gap: 9,
    },
    promptLabel: {
        color: '#8fad87',
        flexBasis: 105,
        flexGrow: 0,
        fontSize: 12,
        fontWeight: '600',
        lineHeight: 18,
        textTransform: 'uppercase',
    },
    promptText: {
        color: '#f3f1e9',
        flex: 1,
        fontSize: 15,
        lineHeight: 24,
    },
    machineGrid: {
        flexDirection: 'row',
        gap: 16,
        marginTop: 42,
    },
    machineCard: {
        backgroundColor: '#fffdf8',
        borderColor: '#d4cfc2',
        borderRadius: 12,
        borderWidth: 1,
        flex: 1,
        minWidth: 0,
        paddingHorizontal: 22,
        paddingVertical: 23,
    },
    machineCardTitle: {
        color: '#1c2c1f',
        fontSize: 17,
        fontWeight: '600',
        lineHeight: 23,
    },
    machineCardBody: {
        color: '#5d665e',
        fontSize: 13,
        lineHeight: 21,
        marginTop: 9,
    },
    machineLinks: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 12,
        marginTop: 17,
    },
    machineLink: {
        color: '#3e6d3c',
        fontSize: 13,
        fontWeight: '600',
        lineHeight: 20,
        textDecorationLine: 'none',
    },
    faqList: {
        borderTopColor: '#d8d2c5',
        borderTopWidth: 1,
        marginTop: 42,
    },
    faqItem: {
        borderBottomColor: '#d8d2c5',
        borderBottomWidth: 1,
        paddingVertical: 25,
    },
    faqQuestion: {
        color: '#1c2b1f',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 23,
    },
    faqAnswer: {
        color: '#59635a',
        fontSize: 15,
        lineHeight: 24,
        marginTop: 10,
        maxWidth: 860,
    },
    finalCta: {
        backgroundColor: '#315c38',
        paddingBottom: 96,
        paddingTop: 96,
        width: '100%',
    },
    finalCtaNarrow: {
        paddingBottom: 72,
        paddingTop: 72,
    },
    finalCtaCopy: {
        alignItems: 'center',
        alignSelf: 'center',
        maxWidth: 820,
        width: '100%',
    },
    finalCtaTitle: {
        color: '#fffdf8',
        fontSize: 32,
        fontWeight: '600',
        lineHeight: 38,
        textAlign: 'center',
    },
    finalCtaTitleNarrow: {
        fontSize: 32,
        lineHeight: 38,
    },
    finalCtaBody: {
        color: '#d4e0d1',
        fontSize: 17,
        lineHeight: 28,
        marginTop: 20,
        maxWidth: 690,
        textAlign: 'center',
    },
    finalCtaNote: {
        color: '#b8cbb5',
        fontSize: 12,
        lineHeight: 19,
        marginTop: 16,
        textAlign: 'center',
    },
});
